function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25H5c-.69 0-1.25-.56-1.25-1.25V9.893h8.5V18c0 .69-.56 1.25-1.25 1.25zm2.25-13H2.75v-.5h2.56l.22-.22.78-.78h3.38l.78.78.22.22h2.56v.5z",
    style: {
      stroke: "none"
    },
    transform: "translate(-2 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5c.271 0 .5-.229.5-.5v-7.357h-7V18c0 .271.229.5.5.5h6m0 1.5H5c-1.1 0-2-.9-2-2V9.143h10V18c0 1.1-.9 2-2 2zm3-13H2V5h3l1-1h4l1 1h3v2z",
    style: {
      fill: "#203662",
      stroke: "none"
    },
    transform: "translate(-2 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/Delete2.3b9b88a875f980b53216d386b79390f5.svg";
export { ForwardRef as ReactComponent };